/** As rotas de download de anexo são anônimas e ficam em outra origem (a API), então o
 *  atributo `download` de um `<a>` é ignorado pelo navegador e o arquivo abriria numa
 *  aba em vez de baixar. Buscar como blob e servir por object URL contorna isso.
 */
export const downloadAttachment = async (url, fileName) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Falha ao baixar o anexo: ${response.status}`);

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
}
